<template>
  <div class="container-fluid p-0" v-bind:class="[{ rtl: this.rtl }]">
    <Search :class="{ 'show': showSearch }" />
    <Header @btnClick="toggleSearch()" />
    <div class="body">
      <div class="view-content">
        <!-- <SideBar /> -->
        <AddCase :class="{ 'show': showAddCase }" />
        <router-view :showAddCase="showAddCase" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Search from "./components/Search.vue";
// import SideBar from "./components/SideBar.vue";
import AddCase from "./components/AddCase.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Header,
    Search,
    // SideBar,
    AddCase,
    Footer,
  },
  data() {
    return {
      showAddCase: false,
      showSearch: false,
      rtl: localStorage.getItem('lang') == 'ar' || true
    }
  },
  beforeMount() {
    this.$i18n.locale = localStorage.getItem('lang') || 'ar';
  },
  afterMount() {
    this.footerMargining();
  },
  methods: {
    toggleAddCase() {
      this.showAddCase = !this.showAddCase
    },
    toggleSearch() {
      document.querySelector('.search-wrapper').classList.add('show');
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap');

.rtl {
  direction: rtl;
}

body {
  margin: 0;
  overflow-x: hidden;
  background-color: #F9F9F9 !important;
}

body * {
  box-sizing: border-box;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 100px;
  min-height: calc(100svh - 100px);
}

#footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}

:root {
  --mainColor: #CF2F34;
  --secondaryColor: #10385C;
  --textColor: #565360;
  --darkGrey: #908e9b;
  --Grey: #F6F7F9;
  --lightGrey: #f2f5f5;
}

hr {
  border-color: #ccc !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  color: var(--mainColor) !important;
}

a {
  text-decoration: none !important;
}

span,
p {
  color: var(--darkGrey);
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-weight: 600 !important;
  gap: 10px;
  border: none;
  padding: 10px 30px !important;
  border: 1px solid var(--mainColor);
  border-radius: 0 !important;
  cursor: pointer;
  transition: 0.2s ease-in-out !important;
}

.btn.btn-main {
  background-color: var(--mainColor) !important;
  color: white !important;
  border-color: var(--mainColor);
}

.btn.btn-secondary {
  background-color: black;
  color: white;
  border-color: white;
  font-size: 1rem;
}

.btn.btn-main:hover {
  background-color: var(--mainColor) !important;
  color: white !important;
}

.btn:focus {
  outline: none;
}

#app {
  font-family: "Cairo", sans-serif;
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app .view-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* min-height: 100svh; */
  transition: 0.5s;
}

.view-content:has(.filter-wrapper.show) {
  margin-inline-end: 290px
}

input,
select,
textarea {
  width: 100%;
  margin: 5px 0;
  padding: 0.5rem;
  box-sizing: border-box;
}

.btn-small {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: none;
  background-color: var(--mainColorDarker);
  color: white !important;
  margin: 0 auto;
  border-radius: 50px;
  transition: 0.3s;
}

.btn-small a {
  color: white !important;
}

.btn-small:hover {
  background-color: var(--mainColor);
}

.select2 {
  width: 100% !important;
  margin: 5px 0;
  font-size: 0.8rem;
}

.select2 .select2-selection {
  height: auto;
  padding: 0.75rem;
  background-color: var(--Grey);
  border: none;
  border-radius: 0.5rem;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding: 0 !important;
  text-align: start;
  line-height: 1.5;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 50%;
  right: 1.5rem;
  transform: translateY(-50%);
}

.select2-dropdown {
  background-color: var(--lightGrey);
  border-color: var(--Grey);
}

:where(input, textarea).form-control {
  background-color: var(--Grey) !important;
  border: none !important;
  border-radius: 0.15rem !important;
  color: var(--textColor);
  font-size: 0.8rem !important;
  margin: 5px 0;
  padding: 0.75rem !important;
}

:where(input, textarea).form-control:focus {
  box-shadow: none !important;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #a8a8a8ae;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #A8A8A8;
}

.rtl .tel {
  direction: ltr;
  justify-content: end;
}

.rtl .fa-chevron-left,
.rtl .fa-chevron-right {
  transform: scaleX(-1);
}

.pagination {
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  padding: 0 15px;
  margin: 30px 0;
}

.pagination .page-number:nth-child(2),
.pagination .page-number:nth-last-child(2) {

  display: none;
}

.pagination .page-number a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  border-radius: 5px;
  padding: 0 5px;
  cursor: pointer;
}

.pagination .page-number a.active {
  padding: 0 13px;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.1);
  background-color: #db3333;
  pointer-events: none;
}

.pagination .page-number a.active span {
  color: #fff;
}

.pagination .pagination-arrow a {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 9px 12px;
  background-color: #db3333;
  color: #fff !important;
  border-radius: 5px;
  cursor: pointer;
}

.pagination .pagination-arrow.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.pagination .pagination-arrow span {
  color: #fff;
}

.page-content {
  position: relative;
  transition: 0.3s;
  padding: 1.25rem;
  background-color: #ffff;
  min-height: calc(100svh - 100px);
}

/* .side-bar~.page-content {
  margin-left: 75px;
}

.side-bar.expanded~.page-content {
  margin-left: 200px;
} */

.add-case.show~.page-content,
.add-case.show~footer {
  margin-right: 300px;
}

.rtl .add-case.show~.page-content,
.rtl .add-case.show~footer {
  margin-right: 0;
  margin-left: 300px;
}


.card {
  width: 100%;
  box-shadow: 0 0 15px -5px #e5e5e5;
  border-color: #efefef !important;
  padding: 1.5rem 1rem;
}

.gm-style button {
  top: 0 !important;
  right: 0 !important;
}

.filter .date-picker {
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 0;
  background-color: #292E30;
}

.filter .dp__menu_inner.dp__flex_display {
  gap: 30px;
}

.filter .date-picker::placeholder {
  color: white;
  font-family: 'Aldrich', sans-serif;
  opacity: 1;
  font-size: 1rem;
}

.rtl .filter .date-picker::placeholder {
  font-family: 'Noto Kufi Arabic', sans-serif;
}

.filter .dp__theme_dark {
  --dp-primary-color: var(--mainColor) !important;
}

.filter .dp__preset_range {
  padding: 0.75rem 1.25rem;
}

.date-picker::placeholder {
  font-size: 18px;
  color: white;
}

.rtl .dp__inner_nav {
  transform: rotate(180deg);
}

.dp__cell_inner {
  border-radius: 0 !important;
}

.rtl .dp__range_start,
.dp__range_end,
.dp__date_hover_end:not(.dp__range_between) {
  border-radius: 0 4px 4px 0 !important;
}

.rtl .dp__range_end,
.rtl .dp__date_hover_end:not(.dp__range_between),
.dp__range_start {
  border-radius: 4px 0 0 4px !important;
}

.rtl .dp__clear_icon {
  right: unset;
  left: 0;
}

.rtl .dp__date_hover_end .dp__month_year_row {
  direction: ltr !important;
}

.rtl .gm-style .gm-style-iw-c {
  padding: 0.5rem 1rem 0 0 !important;
}

.rtl .gm-style .gm-style-iw-d {
  padding: 0 !important;
}

.rtl .gm-style button {
  right: unset !important;
  left: 0 !important;
}

.slider-connect {
  background: var(--mainColor) !important;
}

.slider-txt-dir-rtl.slider-horizontal .slider-handle {
  left: unset !important;
  right: calc(var(--slider-handle-width, 16px)/2*-1) !important;
}

.slider-txt-dir-rtl.slider-horizontal .slider-handle:focus {
  box-shadow: none;
}

.slider-txt-dir-rtl.slider-horizontal .slider-origin>.slider-tooltip-top {
  right: 0% !important;
  background: var(--mainColor) !important;
  border-color: var(--mainColor) !important;
}

@media(max-width: 992px) {
  #app .view-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: calc(100svh - 120px);
  }
}

@media (max-width: 768px) {
  .view-content:has(.filter-wrapper.show) {
    margin-inline-end: 0
  }
}
</style>
